import {actions} from "./actions";

export function getToggles(dispatch) {
  return {
    toggleSaveAsCustomWorklist: payload => dispatch(
      {type: actions.TOGGLE_SAVE_AS_CUSTOM_WORKLIST, payload: payload}),
    toggleDeleteCustomWorklist: payload => dispatch(
      {type: actions.TOGGLE_DELETE_CUSTOM_WORKLIST, payload: payload})
  }
}